import * as React from "react";
import { fromJS } from "immutable";
import { isEqual } from "lodash";
import { IGroupHOCProps, IBeforeGroupRenderEvent, IGroupHOCReturnParams } from "../infinite-interface";
import { result } from "../infinite-utils/infinite-utils-result";
import { amphibiousGetIn } from "helpers/objUtils";
import { formatMessage } from "lib/globalize-util";

export const delimiter = " → ";
export class GroupHOC extends React.PureComponent<IGroupHOCProps> {
    UNSAFE_componentWillMount() {
        this.props.api.on("beforeGroupRender", this.handleBeforeGroupRender);
    }

    componentWillUnmount() {
        this.props.api.off("beforeGroupRender", this.handleBeforeGroupRender);
    }

    UNSAFE_componentWillUpdate(nextProps: IGroupHOCProps) {
        if (nextProps.groupKey !== this.props.groupKey || nextProps.groupDirection !== this.props.groupDirection) {
            this.props.api.trigger("scrollTo", 0);
        }
    }

    render() {
        const { items, groupKey, groupDirection } = this.props;
        // use override if provided, else perform default grouping.
        return this.props.children(
            this.props.groupItemsOverride
                ? this.props.groupItemsOverride(items, groupKey, groupDirection)
                : this.groupItems(),
        );
    }

    private groupItems(): IGroupHOCReturnParams {
        const { items, groupKey, groupDirection } = this.props;
        const currentGroupKey = groupKey?.[0];

        if (!items || !groupDirection || !groupKey) {
            return {
                items,
                groupKey,
                groupDirection,
                isGrouped: !!currentGroupKey,
            };
        }

        // This is copied-pasted from original code. Except, this doesn't have Assortment specific code.
        const groupedItems = [];
        items.forEach((data) => {
            const groupKeyValues = groupKey.map(
                (key) => amphibiousGetIn(data, key.key as Array<string | number>) || formatMessage("N/A"),
            );
            const upperCaseGroupKeyValues = groupKeyValues.map((v) => (typeof v === "string" ? v.toUpperCase() : v));

            const obj = groupedItems.find((grouping) => {
                return isEqual(grouping.groupKeyValues, upperCaseGroupKeyValues);
            });

            if (obj) {
                obj.items.push(data);
            } else {
                groupedItems.push({
                    groupKeyValues: upperCaseGroupKeyValues,
                    items: [data],
                });
            }
        });

        // Sort group
        return {
            items,
            groupKey,
            groupDirection,
            isGrouped: !!currentGroupKey,
            groupedItems: fromJS(groupedItems),
        };
    }

    private handleBeforeGroupRender = ({
        addChildToRender,
        cursor,
        groupKeyValues,
        groupKey,
        items,
    }: IBeforeGroupRenderEvent) => {
        const { onGetGroupDisplayInfo, groupRenderer } = this.props;
        if (groupRenderer && onGetGroupDisplayInfo) {
            const legacyGroupValues = groupKeyValues?.join(delimiter) || "";
            const dimensions = result(onGetGroupDisplayInfo, { groupedValue: legacyGroupValues });
            const style: React.CSSProperties = {
                position: "absolute",
                top: 0,
                left: 0,
                WebkitTransform: `translate3d(0px, ${cursor.top}px, 0px)`,
                transform: `translate3d(0px, ${cursor.top}px, 0px)`,
                zIndex: 1,
                width: "100%",
            };
            addChildToRender(
                <div style={style} key={legacyGroupValues || "__none__" + cursor.top}>
                    {groupRenderer({ groupKeyValues, groupKey, items })}
                </div>,
            );

            cursor.top = cursor.top + dimensions.height;
        }
    };
}
